import Select from 'components/shared/select';
import createSelectOptionsByResource from 'lib/utils/createSelectOptionsByResource';
import classNames from 'classnames';
import styles from './sortDropdown.module.scss';

const SortDropdown = ({ resources, className, sortOption, setSortOption }) => {
  // Copy the resources to delete apply and clearFilters, to pass to the 'createSelectOptions' function.
  const sortingResources = { ...resources };
  delete sortingResources.apply;
  delete sortingResources.clearFilters;
  delete sortingResources.filterAndSort;

  const sortingOptions = createSelectOptionsByResource(sortingResources);

  const handleIndexChange = option => {
    setSortOption(option);
  };

  return (
    <Select
      className={classNames(styles.sortDropdown, className)}
      options={sortingOptions}
      selected={sortOption}
      onChange={option => {
        handleIndexChange(option);
      }}
    />
  );
};

export default SortDropdown;
